// extracted by mini-css-extract-plugin
module.exports = {"distributor":"src-reactapp-App-Distributor---distributor"};